export default function reducer(
  state = {
    app_version: '0.0.0',
  },
  action
) {
  switch (action.type) {
    case 'UPDATE_SETTINGS': {
      return { ...state, ...action.value };
    }
    default:
      return state;
  }
}
